export enum SubscriptionTypes {
  Triggered
};

